import React, { useState } from "react";
import { useParams, Navigate } from "react-router";

const manuais = {
  "yamaha-15-fm-gm": {
    id: "lampada-smart",
    titulo: "Montagem do kit de adaptacao para Yamaha 15 FM - GM",
    descricao: "",
    secoes: [
      {
        numero: "1",
        conteudo: `
          <p>Soltar os 2 parafusos que fixam o filtro de ar e o carburador. Solte-os totalmente do motor para facilitar a instalação. Não se esqueça de observar a posição das conexões.</p>
          <p><strong>Não solte o sistema de aceleração que fica na lateral.</strong> </p>
        `,
        imagens: [
          {
            src: "/images/manuais/yamaha15fm-gm---01.jpg",
          },
        ],
      },
      {
        numero: "2",
        conteudo: `
          <p>Remova totalmente a haste da marcha frente/neutro. Remova também totalmente o manche do acelerador. Retire o corta circuito e não se esqueça de instalá-lo no painel da lancha, Guarde tudo que foi removido para, se decidir no futuro reverter o processo, reinstalá-los. </p>
          <p><strong>Nunca se esqueça de instalar o corta circuito no painel da lancha. </strong></p>
        `,
        imagens: [
          {
            src: "/images/manuais/yamaha15fm-gm---02.jpg",
          },
        ],
      },
      {
        numero: "3",
        conteudo: "<p>Fixar a chapa do kit nos 2 buracos conforme figura.</p>",
        imagens: [
          {
            src: "/images/manuais/yamaha15fm-gm---03.jpg",
          },
        ],
      },
      {
        numero: "3A",
        conteudo:
          "<p>Bata com uma chave de fenda na mola do trambulador para aliviar a pressão (principalmente em motores novos).</p>",
        imagens: [
          {
            src: "/images/manuais/yamaha15fm-gm---03A.jpg",
          },
        ],
      },
      {
        numero: "4",
        conteudo: "<p>Instale a chapa guia do kit.</p>",
        imagens: [
          {
            src: "/images/manuais/yamaha15fm-gm---04.jpg",
          },
        ],
      },
      {
        numero: "5",
        conteudo:
          "<p>Instale a haste da marcha. Fixe-a com um parafuso Phlilips. A haste deve ficar para cima conforme foto.</p>",
        imagens: [
          {
            src: "/images/manuais/yamaha15fm-gm---05.jpg",
          },
        ],
      },
      {
        numero: "6",
        conteudo:
          "<p> 6 - Instale a haste do acelerador preferencialmente para baixo. Faça a regulagem da marcha e do acelerador. Para a regulagem é importante estar com o motor ligado usando um lava motor ou direto com a lancha na água. Monte a haste conforme figura.</p>",
        imagens: [
          {
            src: "/images/manuais/yamaha15fm-gm---06-1.jpg",
          },
          {
            src: "/images/manuais/yamaha15fm-gm---06-2.jpg",
          },
        ],
      },
    ],
  },
};

export default function ManualPage() {
  const { idManual } = useParams();
  const manual = manuais[idManual];

  if (!manual) {
    return <Navigate to="/404" replace />;
  }

  return (
    <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6">
      {/* Cabeçalho */}
      <header className="mb-8 space-y-2">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">
          {manual.titulo}
        </h1>

        {manual.descricao && (
          <p className="text-slate-600">{manual.descricao}</p>
        )}
      </header>

      {/* Seções do manual */}
      <div className="space-y-4">
        {manual.secoes.map((secao) => (
          <section
            key={secao.numero}
            className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm"
          >
            {/* Numeração e título */}
            <header className="flex items-center gap-3 border-b border-slate-200 bg-slate-50 px-4 py-3 sm:px-5">
              <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-slate-800 text-sm font-bold text-white px-2 py-1">
                {secao.numero}
              </span>

              {secao.titulo && (
                <h2 className="text-base font-semibold text-slate-900 sm:text-lg">
                  {secao.titulo}
                </h2>
              )}
            </header>

            {/* Texto e imagens */}
            <div
              className={`grid gap-5 p-4 sm:p-5 ${
                secao.imagens?.length ? "md:grid-cols-2" : "grid-cols-1"
              }`}
            >
              <div
                className="min-w-0 space-y-3 text-md leading-7 text-slate-700 [&_a]:text-blue-600 [&_a]:underline [&_h3]:text-base [&_h3]:font-semibold [&_li]:ml-5 [&_ol]:list-decimal [&_p]:mb-2 [&_strong]:font-semibold [&_strong]:text-slate-900 [&_ul]:list-disc"
                dangerouslySetInnerHTML={{
                  __html: secao.conteudo,
                }}
              />

              {secao.imagens?.length > 0 && (
                <div className="flex flex-col gap-4">
                  {secao.imagens.map((imagem) => (
                    <figure key={imagem.src} className="min-w-0">
                      <img
                        src={imagem.src}
                        alt={imagem.alt}
                        loading="lazy"
                        className="h-auto w-full object-contain max-h-[55vh]"
                      />

                      {imagem.legenda && (
                        <figcaption className="mt-2 text-center text-xs text-slate-500">
                          {imagem.legenda}
                        </figcaption>
                      )}
                    </figure>
                  ))}
                </div>
              )}
            </div>
          </section>
        ))}
      </div>
    </main>
  );
}
